module.exports = __webpack_public_path__ + "img/preview-tablet.01c34430.svg";